<template>
  <div id="home" class="">
    <div style="background-color: white; margin: 10px 20px">
      <div class="pos_container_panel" style="padding-left: 2rem">
        <!--add area-->
        <el-form :inline="true" :model="searchForm" class="demo-form-inline" style="margin-left: 6rem; padding-top: 2rem">
          <el-row>
            <el-col :span="24" style="float: right">
              <div class="grid-content bg-purple-light" style="float: right">
                <el-button type="warning" class="harpIDbtn" style="margin-left: 3rem" @click="addCountry()">新增</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
        <hr style="margin: 1rem -14rem 0rem;background-color: rgb(241 243 245);height: 0.2rem;border: none;"/>
        <!--table-->
        <el-table :data="tableData" border style="width: 90%; margin-top: 50px; margin-left: 100px">
          <el-table-column prop="bedTypeCode" label="床型编码" align="center"></el-table-column>
          <el-table-column prop="bedTypeNameLists.zh-CN" label="床型名称-中文" align="center"></el-table-column>
          <el-table-column prop="bedTypeNameLists.en" label="床型名称-英文" align="center"></el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template #default="scope">
              <div style="display: flex;justify-content: center;">
                <el-button @click="handleChange(scope.row)" type="text" size="small">修改</el-button>
                <el-button type="text" size="small" @click.prevent="deleteRow(scope.row)">删除</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-bottom: 1rem">
        <el-pagination
          class="paginationsty"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          v-model:current-page="currentPage1"
          :page-size="10"
          layout="total, prev, pager, next"
          :total="searchForm.total"
        >
        </el-pagination>
        </div>
      </div>
    </div>
    <!--新增 dialog-->
    <el-dialog
      title="新增床型"
      v-model="dialogFormVisible"
      @close="closeaddDialog('form')"
      
    >
      <el-form :model="form" ref="form">
        <el-form-item
          prop="countryCode"
          label="床型编码:"
          :label-width="formLabelWidth"
          :rules="[
            {
              required: true,
              message: '请输入床型编码',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="form.countryCode"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="床型名称-中文:"
          :label-width="formLabelWidth"
          prop="nationCH"
          :rules="[
            {
              required: true,
              message: '请输入床型名称-中文',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="form.nationCH"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="床型名称-英文:"
          :label-width="formLabelWidth"
          prop="nationEN"
          :rules="[
            {
              required: true,
              message: '请输入床型名称-英文',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="form.nationEN"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="dataSave()">保存</el-button>
          <el-button @click="cancel()">取 消</el-button>
        </span>
      </template>
    </el-dialog>
    <!--修改 dialog-->
    <el-dialog title="修改床型" v-model="changeCountryFlag" >
      <el-form :model="changeForm">
        <el-form-item label="床型编码:" :label-width="formLabelWidth">
          <el-input
            :disabled="true"
            style="width: 58%; margin-left: 85px"
            class="myselect_inner myicon_inner"
            v-model="changeForm.countryCode"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="床型名称-中文:"
          :label-width="formLabelWidth"
          prop="nationCH"
          :rules="[
            {
              required: true,
              message: '请输入床型名称-中文',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="changeForm.nationCH"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="床型名称-英文:"
          :label-width="formLabelWidth"
          prop="nationEN"
          :rules="[
            {
              required: true,
              message: '请输床型-英文',
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            v-model="changeForm.nationEN"
            autocomplete="off"
            style="width: 58%; margin-left: 85px"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="changeSave()">保存</el-button>
          <el-button @click="cancel()">取 消</el-button>
        </span>
      </template>
    </el-dialog>
    <!--        删除 dialog-->
    <el-dialog title="" v-model="deletedialogVisible" width="30%" >
      <span>请确认是否删除</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="confirmDelete">确 定</el-button>
          <el-button @click="cancelDelete">取 消</el-button>
        </span>
      </template>
    </el-dialog>
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      :icon="confirmIcon"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
  </div>
</template>

<script>
import {
  deletecountryList,
  bedtypeList,
  bedtypedelete,
  bedtypeSave,
  deletelocationList,
} from "@/api/shoppingData";
import ConfirmBoxs from "@/components/confirmBoxs.vue";

export default {
  name: "HBERoomtype",
  components: {
    ConfirmBoxs,
  },
  data() {
    return {
      deletedialogVisible: false,
      deleteFlag: false,
      deleteparams: {},
      confirmFlag: false,
      changeRow: {},
      CountryCode: "",
      currentPage1: 1,
      //新增dialog
      confirmIcon: "",
      confirmMsg: "",
      dialogFormVisible: false,
      changeCountryFlag: false,
      form: {
        countryCode: "",
        nationCH: "",
        nationEN: "",
      },
      changeForm: {
        countryCode: "",
        nationCH: "",
        nationEN: "",
      },
      //
      formLabelWidth: "150px",
      selectnation: "",
      selectprovince: "",
      locationCode: "",
      paramsCitycode: "",
      citycode: "",
      cityCode: "",
      clickRow: {},
      tableData: [],
      searchForm: {
        nation: "",
        total: null,
      },
    };
  },
  mounted() {
    this.customSearch();
  },
  methods: {
    closeaddDialog(formRule) {
      console.log(formRule);
      this.$refs[formRule].resetFields();
    },
    //分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.customSearch(val);
      console.log(`当前页: ${val}`);
    },

    addCountry() {
      this.dialogFormVisible = true;
    },
    //新增保存
    async dataSave() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let saveParams = {
            bedTypeCode: this.form.countryCode,
            bedTypeName: this.form.nationCH,
            bedTypeDescription: "",
            iconUrl: "",
            bedTypeNames: [
              {
                languageCode: "zh-CN",
                name: this.form.nationCH,
                description: "",
              },
              {
                languageCode: "en",
                name: this.form.nationEN,
                description: "测试大床房描述",
              },
            ],
          };
          console.log(saveParams, "saveParams");
          bedtypeSave(saveParams)
            .then((res) => {
              if (res.code == 200) {
                if (res.data.error.code == 2003) {
                  this.confirmFlag = true;
                  this.deleteFlag = false;
                  this.confirmMsg = res.data.error.message; //res.message
                  this.currentPage1 = 1;
                } else {
                  this.confirmFlag = true;
                  this.deleteFlag = false;
                  this.confirmMsg = "新增成功";
                  this.dialogFormVisible = false;
                  this.customSearch();
                  this.currentPage1 = 1;
                  this.form = {};
                }
              } else {
                this.confirmFlag = true;
                this.deleteFlag = false;
                // this.confirmMsg = "该床型已添加，请确认后再添加！";
                this.confirmMsg = res.message; //res.message
                this.currentPage1 = 1;
                // this.customSearch();
              }
            })
            .catch(function (error) {
              console.log("新增失败", error.objError);
              this.customSearch();
            });

          // this.form = {};
        }
      });
    },
    // 修改保存
    async changeSave() {
      let saveParams = {
        id: this.changeRow.id,
        bedTypeCode: this.changeForm.countryCode,
        bedTypeName: this.changeForm.nationCH,
        bedTypeDescription: "",
        iconUrl: "",
        bedTypeNames: [
          {
            languageCode: "zh-CN",
            name: this.changeForm.nationCH,
            description: "",
          },
          {
            languageCode: "en",
            name: this.changeForm.nationEN,
            description: "",
          },
        ],
      };
      console.log(saveParams, "修改保存参数");
      await bedtypeSave(saveParams)
        .then((res) => {
          if (res.code == 200) {
            if (res.data.error.code == 2003) {
              this.confirmFlag = true;
              this.deleteFlag = false;
              this.confirmMsg = res.data.error.message;
            } else {
              this.confirmFlag = true;
              this.deleteFlag = false;
              this.confirmMsg = "修改成功";
              this.currentPage1 = 1;
              this.changeCountryFlag = false;
              this.customSearch();
            }
          } else {
            this.confirmFlag = true;
            this.deleteFlag = false;
            this.confirmMsg = res.message;
          }
        })
        .catch(function (error) {
          console.log("修改失败", error.objError);
        });
    },
    //修改button
    handleChange(row) {
      console.log(row);
      this.changeRow = row;
      this.changeCountryFlag = true;
      this.changeForm.countryCode = this.changeRow.bedTypeCode;
      this.changeForm.nationEN = this.changeRow.bedTypeNameLists.en;
      this.changeForm.nationCH = this.changeRow.bedTypeNameLists["zh-CN"];
      // this.changeForm.currencyCode = this.changeRow.currencyCode;
    },
    //取消button
    cancel() {
      this.dialogFormVisible = false;
      this.changeCountryFlag = false;
      this.form.countryCode = "";
      this.form.nationEN = "";
      this.form.nationCH = "";
    },
    //删除dialog
    cancelDelete() {
      this.deletedialogVisible = false;
    },
    //删除
    deleteRow(row) {
      this.deletedialogVisible = true;
      this.deleteparams = {
        params: {
          bedTypeCode: row.bedTypeCode,
        },
      };
    },
    async confirmDelete() {
      this.deletedialogVisible = false;
      bedtypedelete(this.deleteparams)
        .then((res) => {
          if (res.code == 200) {
            this.confirmFlag = true;
            this.confirmMsg = "删除成功";
            this.customSearch();
            this.currentPage1 = 1;
          } else {
            this.confirmFlag = true;
            this.confirmMsg = "删除失败";
          }
        })
        .catch(() => {
          console.log("删除请求失败");
        });
    },
    //搜索button
    async customSearch(int) {
      let searchparams = {
        params: {
          bedTypeCode: "",
          page: int ? int : 1,
          pageSize: 10,
        },
      };
      await bedtypeList(searchparams)
        .then((res) => {
          console.log(res);
          this.tableData = res.data.list;
          this.searchForm.total = res.data.total;
        })
        .catch(function (error) {
          console.log("位置信息 请求失败", error.objError);
        });
    },
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
  },
};
</script>

<style scoped>
.paginationsty {
  float: right;
  margin: 1rem 0;
}
.pos_container_panel {
  padding: 0 16rem 4rem;
}
.harpIDbtn {
  width: 10rem;
  height: 3rem;
  padding: 0 !important;
  font-size: 1rem !important;
}
</style>
